import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import { ReactComponent as More } from '../../../assets/new-icons/plus.svg';
import { ReactComponent as Less } from '../../../assets/new-icons/minus.svg';
import { setTaglia } from '../../../features/userSlice';
import md5 from 'md5';

function Step1({ next }) {
    const dispatch = useDispatch()
    const customerId = useSelector((user) => user.user.info.customer_id)
    const tkn = md5(customerId + 'oYmAIdtki%lu') 
    const taglia = useSelector((user) => user.user.importo_taglia)

    useEffect(() => {
        window.scrollTo(0, 0)
        init()
    },[])

    const init = async () => {
        const url = `https://my.revoluce.it/area_utente/gestione/api/customers/getSogliaTaglia.php?customer_id=${customerId}&tkn_pvt=${tkn}`
        const { data } = await axios.get(url)
        const result = data.data[0]
        dispatch(setTaglia(result.importo_taglia))
    }
    const saveTaglia = async () => {
        const urlSave = `https://my.revoluce.it/area_utente/gestione/api/customers/setSogliaTaglia.php?customer_id=${customerId}&tkn_pvt=${tkn}&soglia_incasso=0&importo_taglia=${taglia}`
        const { data } = await axios.get(urlSave)
        next()
    }
    
    return (
        <>
            <p className="main">Imposta la tua taglia:</p>
            <p className="secondary">
                Per assicurarti lo sconto su tutti i tuoi consumi, a inizio mese ( entro il 5 ) incasseremo la taglia di:
            </p>
            <div className="global">
                <span className="less" onClick={() => taglia <= 10 ? null : dispatch(setTaglia(parseFloat(taglia) - 5))}><Less /></span>
                <p className='value'>{taglia && taglia} €</p>
                <span className="more" onClick={() => dispatch(setTaglia(parseFloat(taglia) + 5))}><More /></span>
            </div>
            <p className="label" style={{textAlign: 'center'}}>
                La taglia minima proposta è calcolata dal nostra algoritmo in base alla tua spesa media mensile.
            </p>
            <div className="buttonActivate" onClick={() => saveTaglia()}>
                <button>Avanti <ArrowForwardIos fontSize='18px'/></button>
            </div>
        </>
    )
}

export default Step1
